import { currentAdminCountryScope } from "helpers/storage";
import { encodeParam } from "utilities/misc";
import { get } from "utilities/network";

const countryCodes = ["NG", "GH", "KE"];
const publicPriceCountryCode = "NG";

const currentPriceCountryCode = () => {
  const countryScope = currentAdminCountryScope();
  return countryCodes.includes(countryScope) ? countryScope : "NG";
};

export const publicCoinsQueryKey = [
  "public",
  "transactions",
  "price",
  publicPriceCountryCode,
];

export const adminCoinsQueryKey = () => [
  "admin",
  "transactions",
  "price",
  currentPriceCountryCode(),
];

export const httpPublicCoins = () => {
  return get(
    `transactions/price?countryCode=${encodeParam(publicPriceCountryCode)}`,
  );
};

export const httpAdminCoins = () => {
  return get(
    `transactions/price?countryCode=${encodeParam(currentPriceCountryCode())}`,
  );
};

export const httpCoins = () => {
  return httpPublicCoins();
};
